import { findMessage } from '@bimser/components';
import { IItem, ReadonlyRecord } from '@bimser/core';
import { Record as ImmutableRecord } from 'immutable';

export interface IRole {
	type: RoleType;
	id: string;
	description?: string;
}
export type Role = ReadonlyRecord<IRole>;

export const AnnouncementRoleFactory = ImmutableRecord<IRole>({
	id: null,
	type: null
});

export const AnnouncementRoleFactoryFromJS = function (role: IRole) {
	return AnnouncementRoleFactory(role);
};

export enum RoleType {
	Role = 2,
	PositionRole = 3,
	ProfessionRole = 4,
	DepartmentRole = 5,
	GroupRole = 8,
	OwnerRole = 9,
	UserRole = 11
}

export const RoleTypeOptions: Array<IItem> = [
	{
		key: RoleType.DepartmentRole.toString(),
		value: RoleType.DepartmentRole,
		title: findMessage.get('100736'),
		text: findMessage.get('100736')
	},
	{
		key: RoleType.PositionRole.toString(),
		value: RoleType.PositionRole,
		title: findMessage.get('100970'),
		text: findMessage.get('100970')
	},
	{
		key: RoleType.GroupRole.toString(),
		value: RoleType.GroupRole,
		title: findMessage.get('100973'),
		text: findMessage.get('100973')
	},
	{
		key: RoleType.ProfessionRole.toString(),
		value: RoleType.ProfessionRole,
		title: findMessage.get('100735'),
		text: findMessage.get('100735')
	}
];

export type VisibleForLists = Partial<Record<RoleType, IVisibleForListItem>>;

export interface IVisibleForListItem {
	list: any[];
	isLoading: boolean;
}
